import React from 'react'
import { ListItem, ListItemAvatar, ListItemText } from '@material-ui/core'
import { 
    getPersonName
} from 'lib-core'
import { useNotes } from './useAddNote'
import { NoteTypeIcon } from './NoteTypeSelector'
import { PostPageList } from './PostPageList'

export const PostNotesList = () => {
    const notes = useNotes()
    return (
        <PostPageList>
            {notes.map((note) => {
                const { text, type } = note
                const name = getPersonName(note.user)

                const primary = name
                const secondary = text
                // const Icon = up ? ThumbsUpIcon : ThumbsDownIcon
                return (
                    <ListItem key={`${note._id}`}>
                        <ListItemAvatar>
                            <NoteTypeIcon type={type} />
                        </ListItemAvatar>
                        <ListItemText primary={primary} secondary={secondary} />
                    </ListItem>
                )
            })}
        </PostPageList>
    )
}
